import React from 'react'
import ReactDOM from 'react-dom'
import './index.less'
import CalculatorPage from "./Containers/CalculatorPage";
import createStore from "./Redux";
require("typeface-montserrat")

export const store = createStore({})

ReactDOM.render(
        <CalculatorPage />,
    document.getElementById('calculator-root'));
